import config from '../config';

const appConfig = config();

const apiBewell = appConfig.apiPrefix;
const { v1 } = appConfig.apiVersion;

export default class AuthService {
  constructor(client) {
    this.client = client;
  }

  tokenValidation() {
    return this.client.get(`${apiBewell}${v1}/auth/token-validation`);
  }

  tokenRefresh() {
    return this.client.post(`${apiBewell}${v1}/auth/refresh-token`);
  }

  deleteTokens() {
    return this.client.post(`${apiBewell}${v1}/auth/delete-tokens`);
  }

  authLogin(payload) {
    return this.client.post(`${apiBewell}${v1}/auth/login`, payload);
  }

  resetMail(payload) {
    return this.client.post(`${apiBewell}${v1}/reset`, payload);
  }

  resetPassword(payload, token) {
    return this.client.get(`${apiBewell}${v1}/reset/${payload}/${token}`);
  }

  CreateResetPassword(payload, id, token) {
    return this.client.post(`${apiBewell}${v1}/reset/${id}/${token}`, payload);
  }

  getOneUserById(id) {
    return this.client.get(`${apiBewell}${v1}/user/${id}`);
  }
}
